export default "__VITE_ASSET__29e8af39__"